// extracted by mini-css-extract-plugin
module.exports = {"mobileWrapper":"main-navigation-mobile_mobileWrapper___sbUR"};